export const M1_UNIT_11 = {
  id: "u11-telling-time",
  title: "Unit 11: Telling the Time",
  topic: "Clock, Hours & Daily Schedule",
  iconType: "clock",
  grammarImage: "/u11-time.jpg",
  grammarText: "Uso de 'It's' para la hora. O'clock (en punto), Half past (y media), Quarter to (menos cuarto).",
  sets: [
    // ----------------------------------------------------------------------
    // SET 1: O'CLOCK (En punto)
    // ----------------------------------------------------------------------
    {
      id: "u11-set1",
      title: "Set 1: It's ... o'clock",
      questions: [
        {
          type: "match",
          q: "Match Time to Phrase",
          pairs: [
            { left: "5:00", right: "Five o'clock" },
            { left: "9:00", right: "Nine o'clock" },
            { left: "12:00", right: "Twelve o'clock" }
          ],
          a: "completed"
        },
        { type: "mc", q: "🕒 3:00 -> It's ___ o'clock.", options: ["three", "third", "thirteen"], a: "three" },
        { type: "mc", q: "🕖 7:00 -> It's ___.", options: ["seven o'clock", "seven clock", "seven hours"], a: "seven o'clock" },
        { type: "input", q: "It is 4:00. It is ___ o'clock.", a: "four" },
        { type: "input", q: "It is 10:00. It is ___ o'clock.", a: "ten" },
        { type: "order", q: "Ordena", words: ["It", "is", "six", "o'clock."], a: "It is six o'clock." },
        { type: "match",
          q: "Connect",
          pairs: [
            { left: "One", right: "1:00" },
            { left: "Eight", right: "8:00" },
            { left: "Eleven", right: "11:00" }
          ],
          a: "completed"
        },
        { type: "mc", q: "What time is it? (2:00)", options: ["Two o'clock", "Two past", "Two"], a: "Two o'clock" },
        { type: "input", q: "It is 5:00. It is ___ o'clock.", a: "five" },
        { type: "order", q: "Ordena", words: ["What", "time", "is", "it?"], a: "What time is it?" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 2: HALF PAST (Y media)
    // ----------------------------------------------------------------------
    {
      id: "u11-set2",
      title: "Set 2: It's Half Past...",
      questions: [
        {
          type: "match",
          q: "Match Digital to Words",
          pairs: [
            { left: "2:30", right: "Half past two" },
            { left: "4:30", right: "Half past four" },
            { left: "10:30", right: "Half past ten" }
          ],
          a: "completed"
        },
        { type: "mc", q: "🕡 6:30 -> It's ___ six.", options: ["half past", "half to", "six thirty"], a: "half past" },
        { type: "mc", q: "🕢 7:30 -> It's half past ___.", options: ["seven", "eight", "six"], a: "seven" },
        { type: "input", q: "9:30 -> It is half ___ nine.", a: "past" },
        { type: "input", q: "1:30 -> It is ___ past one.", a: "half" },
        { type: "order", q: "Ordena", words: ["It", "is", "half", "past", "three."], a: "It is half past three." },
        { type: "match",
          q: "Digital vs Analog",
          pairs: [
            { left: "Thirty minutes", right: "Half past" },
            { left: "5:30", right: "Half past five" },
            { left: "8:30", right: "Half past eight" }
          ],
          a: "completed"
        },
        { type: "mc", q: "12:30 -> It's half past twelve.", options: ["True", "False"], a: "True" },
        { type: "input", q: "11:30 -> It is half past ___.", a: "eleven" },
        { type: "order", q: "Ordena", words: ["It", "is", "half", "past", "five."], a: "It is half past five." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 3: QUARTER PAST (Y cuarto)
    // ----------------------------------------------------------------------
    {
      id: "u11-set3",
      title: "Set 3: It's Quarter Past...",
      questions: [
        {
          type: "match",
          q: "Match Time",
          pairs: [
            { left: "1:15", right: "Quarter past one" },
            { left: "3:15", right: "Quarter past three" },
            { left: "9:15", right: "Quarter past nine" }
          ],
          a: "completed"
        },
        { type: "mc", q: "🕕 6:15 -> It's ___ past six.", options: ["quarter", "half", "fifteen"], a: "quarter" },
        { type: "mc", q: "🕙 10:15 -> It's quarter ___ ten.", options: ["past", "to", "after"], a: "past" },
        { type: "input", q: "2:15 -> It is quarter ___ two.", a: "past" },
        { type: "input", q: "12:15 -> It is ___ past twelve.", a: "quarter" },
        { type: "order", q: "Ordena", words: ["It", "is", "quarter", "past", "eight."], a: "It is quarter past eight." },
        { type: "match",
          q: "15 Minutes",
          pairs: [
            { left: "Quarter past", right: "15 min after" },
            { left: "7:15", right: "Quarter past seven" },
            { left: "11:15", right: "Quarter past eleven" }
          ],
          a: "completed"
        },
        { type: "mc", q: "4:15 -> It's quarter to four. True or False?", options: ["False", "True"], a: "False" },
        { type: "input", q: "5:15 -> It is quarter past ___.", a: "five" },
        { type: "order", q: "Ordena", words: ["It's", "quarter", "past", "one."], a: "It's quarter past one." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 4: QUARTER TO (Menos cuarto)
    // ----------------------------------------------------------------------
    {
      id: "u11-set4",
      title: "Set 4: It's Quarter To...",
      questions: [
        {
          type: "match",
          q: "Match the logic",
          pairs: [
            { left: "2:45", right: "Quarter to three" },
            { left: "4:45", right: "Quarter to five" },
            { left: "8:45", right: "Quarter to nine" }
          ],
          a: "completed"
        },
        { type: "mc", q: "🕡 6:45 -> It's quarter ___ seven.", options: ["to", "past", "for"], a: "to" },
        { type: "mc", q: "🕤 9:45 -> It's quarter to ___.", options: ["ten", "nine", "eight"], a: "ten" },
        { type: "input", q: "1:45 -> It is quarter ___ two.", a: "to" },
        { type: "input", q: "11:45 -> It is quarter to ___.", a: "twelve" },
        { type: "order", q: "Ordena", words: ["It", "is", "quarter", "to", "six."], a: "It is quarter to six." },
        { type: "match",
          q: "Next Hour",
          pairs: [
            { left: "3:45", right: "To four" },
            { left: "5:45", right: "To six" },
            { left: "12:45", right: "To one" }
          ],
          a: "completed"
        },
        { type: "mc", q: "7:45 -> It's quarter to eight.", options: ["True", "False"], a: "True" },
        { type: "input", q: "10:45 -> It is quarter to ___.", a: "eleven" },
        { type: "order", q: "Ordena", words: ["It's", "quarter", "to", "seven."], a: "It's quarter to seven." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 5: DIGITAL TIME (Minutes)
    // ----------------------------------------------------------------------
    {
      id: "u11-set5",
      title: "Set 5: Digital Time",
      questions: [
        {
          type: "match",
          q: "Match Digital",
          pairs: [
            { left: "7:10", right: "Seven ten" },
            { left: "2:20", right: "Two twenty" },
            { left: "5:40", right: "Five forty" }
          ],
          a: "completed"
        },
        { type: "mc", q: "8:25 -> It's eight ___.", options: ["twenty-five", "twenty", "five"], a: "twenty-five" },
        { type: "mc", q: "1:50 -> It's one ___.", options: ["fifty", "fifteen", "five"], a: "fifty" },
        { type: "input", q: "3:05 -> It's three ___ five.", a: "oh" },
        { type: "input", q: "12:10 -> It's twelve ___.", a: "ten" },
        { type: "order", q: "Ordena", words: ["It", "is", "six", "twenty."], a: "It is six twenty." },
        { type: "match",
          q: "Precise Time",
          pairs: [
            { left: "4:05", right: "Four oh five" },
            { left: "9:55", right: "Nine fifty-five" },
            { left: "11:35", right: "Eleven thirty-five" }
          ],
          a: "completed"
        },
        { type: "mc", q: "10:10 -> Ten ten.", options: ["True", "False"], a: "True" },
        { type: "input", q: "2:40 -> It is two ___.", a: "forty" },
        { type: "order", q: "Ordena", words: ["It's", "seven", "fifty-five."], a: "It's seven fifty-five." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 6: TIME OF DAY (Contexto)
    // ----------------------------------------------------------------------
    {
      id: "u11-set6",
      title: "Set 6: Time of Day",
      questions: [
        {
          type: "match",
          q: "Match Time to Period",
          pairs: [
            { left: "7:00 AM", right: "Morning" },
            { left: "1:00 PM", right: "Afternoon" },
            { left: "8:00 PM", right: "Evening" }
          ],
          a: "completed"
        },
        { type: "mc", q: "12:00 PM is ___.", options: ["Noon", "Midnight", "Morning"], a: "Noon" },
        { type: "mc", q: "12:00 AM is ___.", options: ["Midnight", "Noon", "Evening"], a: "Midnight" },
        { type: "input", q: "I eat breakfast in the ___.", a: "morning" },
        { type: "input", q: "I go to sleep at ___.", a: "night" },
        { type: "order", q: "Ordena", words: ["Good", "morning,", "how", "are", "you?"], a: "Good morning, how are you?" },
        { type: "match",
          q: "Greetings",
          pairs: [
            { left: "9 AM", right: "Good Morning" },
            { left: "3 PM", right: "Good Afternoon" },
            { left: "9 PM", right: "Good Evening" }
          ],
          a: "completed"
        },
        { type: "mc", q: "The sun sets in the ___.", options: ["evening", "morning", "noon"], a: "evening" },
        { type: "input", q: "12:00 PM is called ___.", a: "noon" },
        { type: "order", q: "Ordena", words: ["It", "is", "midnight."], a: "It is midnight." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 7: DIALOGUE (Conversation)
    // ----------------------------------------------------------------------
    {
      id: "u11-set7",
      title: "Set 7: Conversation",
      questions: [
        { type: "order", q: "Pregunta", words: ["Excuse", "me,", "what", "time", "is", "it?"], a: "Excuse me, what time is it?" },
        { type: "mc", q: "Reply: 'It is ___.'", options: ["half past two", "two past half", "half two"], a: "half past two" },
        { type: "input", q: "A: What ___ is it? B: It's 5:00.", a: "time" },
        { type: "match",
          q: "Match Q&A",
          pairs: [
            { left: "What time is it?", right: "It's three o'clock" },
            { left: "When is lunch?", right: "At noon" },
            { left: "Is it late?", right: "Yes, it's midnight" }
          ],
          a: "completed"
        },
        { type: "order", q: "Respuesta", words: ["Thank", "you", "very", "much."], a: "Thank you very much." },
        { type: "mc", q: "A: What time is the movie? B: ___ 8:00.", options: ["At", "In", "On"], a: "At" },
        { type: "input", q: "It is 4:30. It is four ___.", a: "thirty" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 8: MIXED PRACTICE (Review 1)
    // ----------------------------------------------------------------------
    {
      id: "u11-set8",
      title: "Set 8: Review",
      questions: [
        { type: "mc", q: "1:15 = ___ one.", options: ["Quarter past", "Quarter to", "Half past"], a: "Quarter past" },
        { type: "mc", q: "1:45 = ___ two.", options: ["Quarter to", "Quarter past", "Half to"], a: "Quarter to" },
        { type: "input", q: "6:00 = Six ___.", a: "o'clock" },
        { type: "match",
          q: "Review",
          pairs: [
            { left: ":00", right: "O'clock" },
            { left: ":15", right: "Quarter past" },
            { left: ":30", right: "Half past" },
            { left: ":45", right: "Quarter to" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["It", "is", "quarter", "to", "five."], a: "It is quarter to five." },
        { type: "input", q: "10:30 = Half ___ ten.", a: "past" },
        { type: "mc", q: "11:55 = ___ to twelve.", options: ["Five", "Fifty", "Fifteen"], a: "Five" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 9: SCHEDULES (Reading - Sin \n)
    // ----------------------------------------------------------------------
    {
      id: "u11-set9",
      title: "Set 9: Schedules",
      questions: [
        { type: "mc", q: "Bus A leaves at 9:00. Bus B leaves at 9:30. Question: When is Bus B?", options: ["Half past nine", "Nine o'clock", "Quarter past nine"], a: "Half past nine" },
        { type: "blank", q: "Class starts at 8:00 AM. It is morning or evening? ___", a: "Morning" },
        { type: "match",
          q: "Match Event to Time",
          pairs: [
            { left: "Breakfast", right: "7:00 AM" },
            { left: "Lunch", right: "12:00 PM" },
            { left: "Dinner", right: "7:00 PM" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["The", "bus", "leaves", "at", "five."], a: "The bus leaves at five." },
        { type: "input", q: "The movie starts ___ (preposition) 8:00.", a: "at" },
        { type: "mc", q: "The store opens at 9 AM and closes at 5 PM. It closes at ___.", options: ["five", "nine", "noon"], a: "five" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 10: MASTERY (Challenge)
    // ----------------------------------------------------------------------
    {
      id: "u11-set10",
      title: "Set 10: Time Master",
      questions: [
        { type: "mc", q: "12:45 = ___", options: ["Quarter to one", "Quarter past twelve", "Quarter to twelve"], a: "Quarter to one" },
        { type: "input", q: "3:15 = Quarter ___ three.", a: "past" },
        { type: "match",
          q: "Ultimate Time Match",
          pairs: [
            { left: "Noon", right: "12:00 PM" },
            { left: "Midnight", right: "12:00 AM" },
            { left: "Dawn", right: "Sunrise" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["See", "you", "at", "half", "past", "six."], a: "See you at half past six." },
        { type: "input", q: "7:50 = Ten ___ eight.", a: "to" },
        { type: "mc", q: "Is 11:59 AM morning or afternoon?", options: ["Morning", "Afternoon"], a: "Morning" },
        { type: "order", q: "Final", words: ["It's", "time", "to", "go!"], a: "It's time to go!" }
      ]
    }
  ]
};